import React from 'react'

const CustomTable = () => {
  return (
    <div>CustomTable</div>
  )
}

export default CustomTable